import {
  Button,
  IconButton as ChakraIconButton,
  IconButtonProps as ChakraIconButtonProps,
  Text,
  Tooltip,
} from '@chakra-ui/react';
import React from 'react';

import { colors } from '../colors';
import { Icon } from './icons';
import { ButtonVariant } from 'packages/common-frontend/theme/components/Button';
import {
  FiDownload,
  FiEdit,
  FiInfo,
  FiPlusCircle,
  FiMinusCircle,
  FiRefreshCw,
  FiSave,
  FiSend,
  FiTrash2,
  FiUpload,
  FiClipboard,
  FiSearch,
  FiX,
  FiPlus,
  FiChevronDown,
  FiChevronUp,
} from 'react-icons/fi';
import { ColorScheme, Sizes } from '~/packages/common-frontend/theme';

type ActiveDiffIconProps = {
  width?: string;
  height?: string;
};
export const ActiveDiffIcon = ({
  width = '16',
  height = '16',
}: ActiveDiffIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth=".1"
  >
    <path
      d="M2.75 1.5C2.6837 1.5 2.62011 1.52634 2.57322 1.57322C2.52634 1.62011 2.5 1.6837 2.5 1.75V14.25C2.5 14.388 2.612 14.5 2.75 14.5H13.25C13.3163 14.5 13.3799 14.4737 13.4268 14.4268C13.4737 14.3799 13.5 14.3163 13.5 14.25V4.664C13.5001 4.63115 13.4936 4.59861 13.4811 4.56823C13.4686 4.53786 13.4502 4.51026 13.427 4.487L10.513 1.573C10.4897 1.5498 10.4621 1.53141 10.4318 1.51888C10.4014 1.50636 10.3689 1.49994 10.336 1.5H2.75ZM1 1.75C1 0.784 1.784 0 2.75 0H10.336C10.8 0 11.245 0.184 11.573 0.513L14.487 3.427C14.816 3.755 15 4.2 15 4.664V14.25C15 14.7141 14.8156 15.1592 14.4874 15.4874C14.1592 15.8156 13.7141 16 13.25 16H2.75C2.28587 16 1.84075 15.8156 1.51256 15.4874C1.18437 15.1592 1 14.7141 1 14.25V1.75ZM8 3.25C8.19891 3.25 8.38968 3.32902 8.53033 3.46967C8.67098 3.61032 8.75 3.80109 8.75 4V5.5H10.25C10.4489 5.5 10.6397 5.57902 10.7803 5.71967C10.921 5.86032 11 6.05109 11 6.25C11 6.44891 10.921 6.63968 10.7803 6.78033C10.6397 6.92098 10.4489 7 10.25 7H8.75V8.5C8.75 8.69891 8.67098 8.88968 8.53033 9.03033C8.38968 9.17098 8.19891 9.25 8 9.25C7.80109 9.25 7.61032 9.17098 7.46967 9.03033C7.32902 8.88968 7.25 8.69891 7.25 8.5V7H5.75C5.55109 7 5.36032 6.92098 5.21967 6.78033C5.07902 6.63968 5 6.44891 5 6.25C5 6.05109 5.07902 5.86032 5.21967 5.71967C5.36032 5.57902 5.55109 5.5 5.75 5.5H7.25V4C7.25 3.80109 7.32902 3.61032 7.46967 3.46967C7.61032 3.32902 7.80109 3.25 8 3.25ZM5 11.25C5 11.0511 5.07902 10.8603 5.21967 10.7197C5.36032 10.579 5.55109 10.5 5.75 10.5H10.25C10.4489 10.5 10.6397 10.579 10.7803 10.7197C10.921 10.8603 11 11.0511 11 11.25C11 11.4489 10.921 11.6397 10.7803 11.7803C10.6397 11.921 10.4489 12 10.25 12H5.75C5.55109 12 5.36032 11.921 5.21967 11.7803C5.07902 11.6397 5 11.4489 5 11.25Z"
      fill="currentColor"
    />
  </svg>
);

export const InactiveDiffIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth=".1"
  >
    <path
      d="M2.75 1.5C2.6837 1.5 2.62011 1.52634 2.57322 1.57322C2.52634 1.62011 2.5 1.6837 2.5 1.75V14.25C2.5 14.388 2.612 14.5 2.75 14.5H13.25C13.3163 14.5 13.3799 14.4737 13.4268 14.4268C13.4737 14.3799 13.5 14.3163 13.5 14.25V4.664C13.5001 4.63115 13.4936 4.59861 13.4811 4.56823C13.4686 4.53786 13.4502 4.51026 13.427 4.487L10.513 1.573C10.4897 1.5498 10.4621 1.53141 10.4318 1.51888C10.4014 1.50636 10.3689 1.49994 10.336 1.5H2.75ZM1 1.75C1 0.784 1.784 0 2.75 0H10.336C10.8 0 11.245 0.184 11.573 0.513L14.487 3.427C14.816 3.755 15 4.2 15 4.664V14.25C15 14.7141 14.8156 15.1592 14.4874 15.4874C14.1592 15.8156 13.7141 16 13.25 16H2.75C2.28587 16 1.84075 15.8156 1.51256 15.4874C1.18437 15.1592 1 14.7141 1 14.25V1.75ZM8 3.25C8.19891 3.25 8.38968 3.32902 8.53033 3.46967C8.67098 3.61032 8.75 3.80109 8.75 4V5.5H10.25C10.4489 5.5 10.6397 5.57902 10.7803 5.71967C10.921 5.86032 11 6.05109 11 6.25C11 6.44891 10.921 6.63968 10.7803 6.78033C10.6397 6.92098 10.4489 7 10.25 7H8.75V8.5C8.75 8.69891 8.67098 8.88968 8.53033 9.03033C8.38968 9.17098 8.19891 9.25 8 9.25C7.80109 9.25 7.61032 9.17098 7.46967 9.03033C7.32902 8.88968 7.25 8.69891 7.25 8.5V7H5.75C5.55109 7 5.36032 6.92098 5.21967 6.78033C5.07902 6.63968 5 6.44891 5 6.25C5 6.05109 5.07902 5.86032 5.21967 5.71967C5.36032 5.57902 5.55109 5.5 5.75 5.5H7.25V4C7.25 3.80109 7.32902 3.61032 7.46967 3.46967C7.61032 3.32902 7.80109 3.25 8 3.25ZM5 11.25C5 11.0511 5.07902 10.8603 5.21967 10.7197C5.36032 10.579 5.55109 10.5 5.75 10.5H10.25C10.4489 10.5 10.6397 10.579 10.7803 10.7197C10.921 10.8603 11 11.0511 11 11.25C11 11.4489 10.921 11.6397 10.7803 11.7803C10.6397 11.921 10.4489 12 10.25 12H5.75C5.55109 12 5.36032 11.921 5.21967 11.7803C5.07902 11.6397 5 11.4489 5 11.25Z"
      fill="currentColor"
    />
    <line
      x1="14.6237"
      y1="16.3293"
      x2="0.623711"
      y2="0.329253"
      fill="currentColor"
      strokeWidth="2"
    />
  </svg>
);

type BaseIconButtonProps = Omit<
  ChakraIconButtonProps,
  'aria-label' | 'icon'
> & {
  ariaLabel: string;
  label: string;
  icon: React.ReactElement<any, string | React.JSXElementConstructor<any>>;
};

export type IconButtonProps = Omit<
  BaseIconButtonProps,
  'ariaLabel' | 'label'
> & {
  ariaLabel?: string;
  label?: string;
};

export const IconButton = ({
  ariaLabel,
  icon,
  label,
  ...remainingProps
}: BaseIconButtonProps) => {
  const { isDisabled, variant } = remainingProps;
  return (
    <Tooltip label={label} isDisabled={isDisabled}>
      <ChakraIconButton
        {...remainingProps}
        aria-label={ariaLabel}
        icon={icon}
        variant={variant || 'ghost'}
      />
    </Tooltip>
  );
};

// !TODO @eldarshamukhamedov Replace <IconButton /> with this, but need to implement all variants
type IconButtonV2Props = {
  // Main component props
  colorScheme?: ColorScheme;
  size?: Sizes;
  icon: React.ComponentProps<typeof ChakraIconButton>['icon'];
  isActive?: boolean;
  isDisabled?: boolean;
  isLoading?: boolean;
  tooltipEnabled?: boolean;
  hasDotIndicator?: boolean;
  'aria-label': string;
  label?: React.ReactNode;
  onClick?: React.ComponentProps<typeof ChakraIconButton>['onClick'];
  placement?: React.ComponentProps<typeof Tooltip>['placement'];
  variant: ButtonVariant;

  // Pass-through props
  IconButtonProps?: Partial<React.ComponentProps<typeof ChakraIconButton>>;
  TooltipProps?: Partial<React.ComponentProps<typeof Tooltip>>;
};
export const IconButtonV2 = React.forwardRef<
  HTMLButtonElement,
  IconButtonV2Props
>((props: IconButtonV2Props, ref) => {
  const {
    colorScheme = 'v2-aurora',
    size = 'md',
    icon,
    isActive = false,
    isDisabled = false,
    isLoading = false,
    tooltipEnabled = true,
    hasDotIndicator = false,
    'aria-label': ariaLabel,
    label,
    onClick,
    placement = 'auto',
    variant,
    IconButtonProps = {},
    TooltipProps = {},
  } = props;

  const sizes = (sm: string, md: string, lg: string) => {
    if (size === 'sm') return sm;
    if (size === 'lg') return lg;
    return md;
  };

  const dotIndicatorStyles = {
    content: "''",
    position: 'absolute',
    top: sizes('0.25rem', '0.45rem', '0.65rem'),
    right: sizes('0.25rem', '0.45rem', '0.65rem'),
    height: '0.4rem',
    width: '0.4rem',
    borderRadius: '0.4rem',
    border: '1px solid white',
    background: colors.red['400'],
  };

  return (
    <Tooltip
      isDisabled={!tooltipEnabled}
      label={label || ariaLabel}
      placement={placement}
      {...TooltipProps}
    >
      <ChakraIconButton
        ref={ref}
        aria-label={ariaLabel}
        colorScheme={colorScheme}
        size={size}
        icon={icon}
        isActive={isActive}
        isDisabled={isDisabled}
        isLoading={isLoading}
        onClick={onClick}
        variant={variant}
        position="relative"
        flexShrink={0}
        _after={hasDotIndicator ? dotIndicatorStyles : {}}
        {...IconButtonProps}
      />
    </Tooltip>
  );
});
IconButtonV2.displayName = 'IconButtonV2';

export const PlusIconButton = ({
  ariaLabel,
  label,
  ...remainingProps
}: Omit<IconButtonProps, 'icon'>) => {
  return (
    <IconButton
      {...remainingProps}
      ariaLabel={ariaLabel || 'add'}
      icon={<FiPlus />}
      label={label || 'Add'}
    />
  );
};

export const AddIconButton = ({
  ariaLabel,
  label,
  ...remainingProps
}: Omit<IconButtonProps, 'icon'>) => {
  return (
    <IconButton
      {...remainingProps}
      ariaLabel={ariaLabel || 'add'}
      icon={<FiPlusCircle />}
      label={label || 'Add'}
    />
  );
};

export const MinusIconButton = ({
  ariaLabel,
  label,
  ...remainingProps
}: Omit<IconButtonProps, 'icon'>) => {
  return (
    <IconButton
      {...remainingProps}
      icon={<FiMinusCircle />}
      label={label || 'Minus'}
      ariaLabel={ariaLabel || 'minus'}
    />
  );
};

export const ResetIconButton = ({
  ariaLabel,
  label,
  ...remainingProps
}: Omit<IconButtonProps, 'icon'>) => {
  return (
    <IconButton
      {...remainingProps}
      ariaLabel={ariaLabel || 'reset'}
      icon={<FiRefreshCw />}
      label={label || 'Reset'}
    />
  );
};

export const DeleteIconButton = ({
  ariaLabel,
  label,
  ...remainingProps
}: Omit<IconButtonProps, 'icon'>) => {
  return (
    <IconButton
      {...remainingProps}
      ariaLabel={ariaLabel || 'delete'}
      icon={<FiTrash2 />}
      label={label || 'Delete'}
    />
  );
};

export const DownloadIconButton = ({
  ariaLabel,
  label,
  ...remainingProps
}: Omit<IconButtonProps, 'icon'>) => {
  return (
    <IconButton
      {...remainingProps}
      ariaLabel={ariaLabel || 'download'}
      icon={<FiDownload />}
      label={label || 'download'}
    />
  );
};

export const EditIconButton = ({
  ariaLabel,
  label,
  ...remainingProps
}: Omit<IconButtonProps, 'icon'>) => {
  return (
    <IconButton
      {...remainingProps}
      ariaLabel={ariaLabel || 'edit'}
      icon={<FiEdit />}
      label={label || 'Edit'}
    />
  );
};

export const InfoIconButton = ({
  ariaLabel,
  label,
  ...remainingProps
}: Omit<IconButtonProps, 'icon'>) => {
  return (
    <IconButton
      {...remainingProps}
      ariaLabel={ariaLabel || 'info'}
      icon={<FiInfo />}
      label={label || 'Info'}
    />
  );
};

export const SaveIconButton = ({
  ariaLabel,
  label,
  ...remainingProps
}: Omit<IconButtonProps, 'icon'>) => {
  return (
    <IconButton
      {...remainingProps}
      ariaLabel={ariaLabel || 'save'}
      icon={<FiSave />}
      label={label || 'Save'}
    />
  );
};

export const UploadIconButton = ({
  ariaLabel,
  label,
  ...remainingProps
}: Omit<IconButtonProps, 'icon'>) => {
  return (
    <IconButton
      {...remainingProps}
      ariaLabel={ariaLabel || 'upload'}
      icon={<FiUpload />}
      label={label || 'upload'}
    />
  );
};

export const PasteIconButton = ({
  ariaLabel,
  label,
  ...remainingProps
}: Omit<IconButtonProps, 'icon'>) => {
  return (
    <IconButton
      {...remainingProps}
      ariaLabel={ariaLabel || 'paste'}
      icon={<FiClipboard />}
      label={label || 'paste'}
    />
  );
};

export const SearchIconButton = ({
  ariaLabel,
  label,
  ...remainingProps
}: Omit<IconButtonProps, 'icon'>) => {
  return (
    <IconButton
      {...remainingProps}
      ariaLabel={ariaLabel || 'search'}
      icon={<FiSearch />}
      label={label || 'search'}
    />
  );
};

export const EmailIconButton = ({
  ariaLabel,
  label,
  ...remainingProps
}: Omit<IconButtonProps, 'icon'>) => {
  return (
    <IconButton
      {...remainingProps}
      ariaLabel={ariaLabel || 'email'}
      icon={<FiSend />}
      label={label || 'email'}
    />
  );
};

export const XIconButton = ({
  ariaLabel,
  label,
  ...remainingProps
}: Omit<IconButtonProps, 'icon'>) => {
  return (
    <IconButton
      {...remainingProps}
      ariaLabel={ariaLabel || 'cancel'}
      label={label || 'cancel'}
      icon={<FiX />}
    />
  );
};

export const CopyIconButton = ({
  ariaLabel,
  label,
  ...remainingProps
}: Omit<IconButtonProps, 'icon'>) => {
  return (
    <IconButton
      {...remainingProps}
      ariaLabel={ariaLabel || 'copy'}
      label={label || 'copy'}
      icon={<Icon icon="copy" />}
    />
  );
};

type ChevronIconButtonProps = {
  openState: boolean;
  setOpenState: (value: React.SetStateAction<boolean>) => void;
} & Omit<ChakraIconButtonProps, 'aria-label'>;
export const ChevronIconButton = ({
  openState,
  setOpenState,
  ...remainingProps
}: ChevronIconButtonProps) => {
  return (
    <IconButton
      variant="ghost"
      {...remainingProps}
      ariaLabel={openState ? 'close' : 'open'}
      label={openState ? 'Close' : 'Open'}
      icon={openState ? <FiChevronUp /> : <FiChevronDown />}
      onClick={() => setOpenState((prev) => !prev)}
    />
  );
};

export const AddTextButton = ({
  ariaLabel,
  label,
  tooltip,
  ...remainingProps
}: Omit<IconButtonProps, 'icon'> & { tooltip?: string }) => {
  return (
    <Tooltip label={tooltip ?? ''}>
      <span>
        <Button
          {...remainingProps}
          aria-label={ariaLabel || 'copy'}
          minW="fit-content"
          borderWidth="2px"
          colorScheme="aurora"
          backgroundColor="white"
          variant="outline"
        >
          <Icon icon="plus" color={colors.aurora[400]} />
          <Text ml="16px" color={colors.aurora[400]}>
            {label}
          </Text>
        </Button>
      </span>
    </Tooltip>
  );
};

export const DeleteTextButton = ({
  ariaLabel,
  label,
  ...remainingProps
}: Omit<IconButtonProps, 'icon'>) => {
  return (
    <Button
      {...remainingProps}
      aria-label={ariaLabel || 'copy'}
      minW="fit-content"
      borderWidth="2px"
      colorScheme="aurora"
      backgroundColor="white"
      variant="outline"
    >
      <Icon icon="trash" color={colors.aurora[400]} />
      <Text ml="16px" color={colors.aurora[400]}>
        {label}
      </Text>
    </Button>
  );
};
